export const shop_material_url: string = "shop_material";
export const shop_color_url: string = "shop_color";
